const r = (n) => {
  const t = String(n);
  return /^\d+$/.test(t) ? `${t}px` : t;
};
export {
  r as toCSSLengthValue
};
